import React, { useEffect, useState } from 'react';
import fakeData from '../../fakeData/fakeData';
import Club from '../Club/Club';
import Players from '../Players/Players';
import './Dashboard.css'

const Dashboard = () => {
    const fake10 = fakeData;
    const [members, setMembers] = useState(fake10);
    const [club, setClub] = useState([]);


    const handleAddMember = (fakeData) => {
        const newClub = [...club, fakeData];
        setClub(newClub);
    }
    useEffect (() => {
        setMembers(fakeData)
    }, [])

    return (
        <div className="members-container">
            <div className="players">
                <div className="row">
                {
                    members.map(mb => <Players
                        handleAddMember = {handleAddMember}
                         member={mb}> </Players>)
                }
                </div>
            </div> 
            <div className="club-container">
                <Club club={club}></Club>
            </div>
        </div>
    );
};

export default Dashboard;